<template>
  <div :class="isClass">
    <div class="w">
      <div class="left">
        <!-- <i class="el-icon-close"></i> -->
        <img src="../assets/img/verify/app1.png" alt />
        <div class="title">
          <h3>音乐窝</h3>
          <p>多一种沟通方式</p>
        </div>
      </div>
      <div class="loading" @click="handleDownload">下载</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClass: "download", //在页面上控制元素的显示隐藏
      screenHeight: document.body.clientHeight,
      originHeight: document.body.clientHeight, //默认高度在watch里拿来做比较
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight;
        that.screenHeight = window.screenHeight;
      })();
    };
  },
  watch: {
    screenHeight(val) {
      // val为获取的新的屏幕高度;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      if (this.originHeight != val && isAndroid) {
        this.isClass = "downloadt";
        this.$emit("setGaodu");
      } else {
        this.isClass = "download";
      }
    },
  },
  methods: {
    handleDownload() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
      if (isIos) {
        // console.log("ios");
        var loadDateTime = new Date();
        window.setTimeout(function () {
          var timeOutDateTime = new Date();
          if (timeOutDateTime - loadDateTime < 5000) {
            window.location = "itms-apps://itunes.apple.com/app/id1238121127";
          } else {
            window.close();
          }
        }, 25);
        window.location = "liveconwaysmusiccom://";
      } else {
        // console.log("az");
        window.location = "scheme://musicwow.com";
        setTimeout(function () {
          window.location =
            "https://sj.qq.com/myapp/detail.htm?apkName=com.conwaysmusic.live";
        }, 300);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.download {
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  font-family: "PingFang SC";
  width: 100%;
  display: flex;
  justify-content: center;
  .w {
    height: 72px;
    width: 343px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      i {
        margin-right: 20px;
        font-size: 18px;
        font-weight: 600;
        color: #979797;
      }
      img {
        width: 54px;
        height: 54px;
      }
      .title {
        margin-left: 10px;
        h3 {
          font-size: 16px;
          text-align: left;
          color: #333338;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #979797;
          line-height: 17px;
          letter-spacing: 4px;
        }
      }
    }
    .loading {
      font-size: 12px;
      font-weight: 400;
      color: #07d1aa;
    }
  }
}
.downloadt {
  background-color: #fff;
  font-family: "PingFang SC";
  width: 100%;
  display: flex;
  justify-content: center;
  .w {
    height: 72px;
    width: 343px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      i {
        margin-right: 20px;
        font-size: 18px;
        font-weight: 600;
        color: #979797;
      }
      img {
        width: 54px;
        height: 54px;
      }
      .title {
        margin-left: 10px;
        h3 {
          font-size: 16px;
          text-align: left;
          color: #333338;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #979797;
          line-height: 17px;
          letter-spacing: 4px;
        }
      }
    }
    .loading {
      font-size: 12px;
      font-weight: 400;
      color: #07d1aa;
    }
  }
}
</style>